var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "nav-icon",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0598 7.6201C9.99832 7.6201 11.5698 6.04862 11.5698 4.1101C11.5698 2.17158 9.99832 0.600098 8.0598 0.600098C6.12129 0.600098 4.5498 2.17158 4.5498 4.1101C4.5498 6.04862 6.12129 7.6201 8.0598 7.6201Z",
    stroke: "#8295B6",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.51 16.4002C15.17 16.4002 15.68 15.7602 15.47 15.1202C14.46 11.9902 11.53 9.72021 8.06005 9.72021C4.59005 9.72021 1.66005 11.9902 0.650047 15.1202C0.450047 15.7502 0.950047 16.4002 1.61005 16.4002H14.51Z",
    stroke: "#8295B6",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonas);
export default __webpack_public_path__ + "static/media/personas.b41032db7bd122e24d7698ac7c261c91.svg";
export { ForwardRef as ReactComponent };